import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { CardComponent } from "./card.component";

@NgModule({
  declarations: [CardComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [CardComponent],
})
export class CardModule {}
